import axios from './axios';
import qs from "qs";

function service() {

    function fetchSupportedLanguages() {
        return axios.get(`supported-languages`).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function fetchTranslationsOfKey(data) {
        return axios.get(`translations-of-key`, { params: data, paramsSerializer: params => qs.stringify(params, { encodeValuesOnly: true })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        fetchSupportedLanguages,
        fetchTranslationsOfKey
    }
}

export default service
